<template>
    <v-card>
        <v-card-title>Applications</v-card-title>
        <v-card-text>
            <v-data-table :items="applications"></v-data-table>
        </v-card-text>
    </v-card>
</template>
<script setup lang="ts">

import { withLoadingScreen } from "@/lib/loading";
import { applicationsAPI, SavedApplication } from "@/services/applications/applicationsAPI";
import { onMounted, ref } from "vue";

type ExperimentLike = {
    code: string;
}

const { experiment } = defineProps<{
    experiment: ExperimentLike;
}>();

const applications = ref<SavedApplication[]>([]);

onMounted(async () => {
    await fetchApplications();
});

async function fetchApplications() {
    await withLoadingScreen(async () => {
        applications.value = await applicationsAPI.fetchApplicationsForExperiment(experiment.code)
    });
}
</script>
